
/* Hola SBM - swatches for color, dual-color, fantasy and pattern variants */
(function() {
  'use strict';
  var colors = {
    'nero':'#191919','nera':'#191919','black':'#191919',
    'bianco':'#f9f9f7','bianca':'#f9f9f7','white':'#f9f9f7',
    'panna':'#f4eddf','crema':'#eee1cf','avorio':'#f3eadb','ivory':'#f3eadb',
    'beige':'#d8c5a9','beje':'#d8c5a9','beije':'#d8c5a9','sabbia':'#d2bd99',
    'champagne':'#e1c9a8','biscotto':'#ba966b','nude':'#d8b5a3',
    'nocciola':'#b29170','caramello':'#a97a4f','camel':'#b98a5c',
    'cammello':'#b98a5c','taupe':'#a59789','tortora':'#a59789',
    'fango':'#857a6e','terra':'#aa7553','coccio':'#b96845','terracotta':'#bc6f52',
    'mattone':'#b66545','cuoio':'#a4683b','ruggine':'#a35132',
    'marrone':'#76513b','marroncino':'#a27b61','marron':'#76513b',
    'brown':'#76513b','moka':'#665044','mocca':'#665044','coffee':'#665044',
    'caffe':'#665044','cioccolato':'#523529','cioccolata':'#523529',
    'testa di moro':'#372923','moro':'#372923',
    'bordeaux':'#74283d','vinaccia':'#6a2c48','burgundy':'#74283d',
    'rosso':'#cc383d','red':'#cc383d','ciliegia':'#b62c46','corallo':'#ec776b',
    'rosa':'#e5a7bd','pink':'#e5a7bd','rosa antico':'#c8939d',
    'rosa cipria':'#e1b6b7','cipria':'#e1b6b7','rosa barbie':'#f05c9f',
    'rosa fluo':'#ff4ab0','rosa chiaro':'#f0c1d1','rosa prugna':'#a46b88',
    'fucsia':'#d52890','fuxia':'#d52890','magenta':'#d32381',
    'pesca':'#efa98b','albicocca':'#e7a171','prugna':'#73334c',
    'viola':'#8147a6','purple':'#8147a6','lilla':'#bda5db',
    'lavanda':'#ad9bd1','glicine':'#bca6cf','indaco':'#42499b',
    'blu':'#3266a7','blue':'#3266a7','blu navy':'#263451',
    'blu notte':'#202c4d','blu scuro':'#293956','navy':'#263451',
    'blu royal':'#284dc0','royal':'#284dc0','blu elettrico':'#245dd6',
    'blu cobalto':'#2556bc','cobalto':'#2556bc',
    'blu ottanio':'#187386','ottanio':'#187386','blu avio':'#708da6',
    'azzurro avion':'#6e94ae','azzurro':'#90bfdc','celeste':'#b2d6e9',
    'azzurro polvere':'#a6bbca','azzurro chiaro':'#b4d7e9','polvere':'#a6bbca',
    'denim chiaro':'#9ab3cb','denim scuro':'#375675','denim blu':'#547ea7',
    'denim nero':'#3d4348','denim marrone':'#775b4d','denim':'#6186a8',
    'petrolio':'#236f77','verde petrolio':'#236f77','blu petrolio':'#236f77',
    'turchese':'#3cbac0','tiffany':'#79cbca','verde acqua':'#77c9bd',
    'verde':'#528c5d','green':'#528c5d','verde militare':'#606a48',
    'militare':'#606a48','khaki':'#99936e','kaki':'#99936e',
    'verde oliva':'#808b53','oliva':'#808b53','verde bosco':'#3c654b',
    'verde scuro':'#315740','verde bottiglia':'#25543e',
    'verde smeraldo':'#18886b','smeraldo':'#18886b',
    'verde mela':'#93bb4e','verde lime':'#a5d53c','verde acido':'#b6dc34',
    'verde salvia':'#a2b59a','salvia':'#a2b59a','eucalipto':'#8ba694',
    'verde eucalipto':'#8ba694','verde pastello':'#b8d5ad',
    'menta':'#a0d1b6','verde menta':'#a0d1b6','verde desert':'#8e9b73',
    'giallo':'#f0d258','yellow':'#f0d258','giallo pastello':'#f8e69d',
    'giallo fluo':'#eaff38','giallo lime':'#d9ed47',
    'giallo sole':'#fad03e','senape':'#b79540',
    'arancione':'#ea8d49','arancio':'#ea8d49','orange':'#ea8d49',
    'grigio':'#999a9e','grey':'#999a9e','gray':'#999a9e',
    'grigio chiaro':'#c8c9cb','grigio scuro':'#54575b',
    'antracite':'#4e5053','fume':'#a3a2a4',
    'oro':'#cbab5f','gold':'#cbab5f','argento':'#bfc2c7','silver':'#bfc2c7',
    'cristallo':'#e6e9e9'
  };
  var keys = Object.keys(colors).sort(function(a,b) {return b.length-a.length;});
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase().trim();
    if(s.normalize) s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    return s.replace(/\s+/g,' ');
  }
  function solid(part) {
    var n=norm(part);
    if(Object.prototype.hasOwnProperty.call(colors,n))return colors[n];
    for(var i=0;i<keys.length;i++) {
      var k=keys[i];
      if(n.indexOf(k)>=0) return colors[k];
    }
    return null;
  }
  function pattern(name) {
    var n=norm(name);
    if(/zebrat/.test(n)) return 'repeating-linear-gradient(50deg,#f7f5ed 0px 4px,#313033 4px 7px,#f7f5ed 7px 11px)';
    if(/pitonat|serpent/.test(n))return 'repeating-linear-gradient(50deg,#a79a83 0px 3px,#6b6659 3px 5px,#d6b990 5px 8px,#7b6b5b 8px 9px)';
    if(/leopard|maculat|animalier|animals/.test(n)) {
      var base=/rosa/.test(n)?'#e3a6bc':/verde/.test(n)?'#84936d':/tortora/.test(n)?'#aaa091':/beige|chiaro/.test(n)?'#e5ceaf':'#d0aa76';
      var dark=/rosa/.test(n)?'#674259':/verde/.test(n)?'#353e28':'#533b2c';
      return 'radial-gradient(ellipse at 30% 26%,'+dark+' 0px 2px,transparent 3px),radial-gradient(ellipse at 78% 70%,'+dark+' 0px 2.7px,transparent 3.7px),radial-gradient(ellipse at 24% 80%,'+dark+' 0px 1.8px,transparent 3px),'+base;
    }
    if(/mimetic|camouflage/.test(n)){
      var a=/corallo/.test(n)?'#dc907e':/blu/.test(n)?'#427b9c':/grigio/.test(n)?'#8c9091':'#82906d';
      var b=/blu/.test(n)?'#9cabb9':/corallo/.test(n)?'#b9665b':'#4c5d40';
      return 'radial-gradient(ellipse at 15% 18%,'+b+' 0px 5px,transparent 6px),radial-gradient(ellipse at 80% 69%,#555c50 0px 6px,transparent 7px),radial-gradient(ellipse at 75% 10%,'+b+' 0px 4px,transparent 5px),'+a;
    }

    if(/tigrat/.test(n))return 'repeating-linear-gradient(115deg,#c98c45 0px 3px,#3d332b 3px 5px,#dba957 5px 9px,#3d332b 9px 10px)';
    if(/capri ceramica/.test(n))return 'radial-gradient(circle at 20% 25%,#315fa1 0px 2px,transparent 3px),repeating-linear-gradient(40deg,#f8f5ed 0px 6px,#4c78ae 6px 8px,#f8f5ed 8px 12px)';
    if(/desert paisley/.test(n))return 'radial-gradient(circle at 68% 30%,#af6e45 0px 4px,transparent 5px),repeating-linear-gradient(120deg,#e3cdaf 0px 8px,#b08d6d 8px 11px,#d8bca3 11px 17px)';
    if(/floreal|desert bloom|desert garden|jungle autunno/.test(n)){
      var base=/rubino/.test(n)?'#8a3046':/jungle/.test(n)?'#8c9458':/desert/.test(n)?'#d5b89a':'#e5caba';
      var petals=/rubino/.test(n)?'#f3b3be':/jungle/.test(n)?'#bd6642':'#b85268';
      return 'radial-gradient(circle at 26% 22%,'+petals+' 0px 2px,transparent 3px),radial-gradient(circle at 78% 68%,'+petals+' 0px 2px,transparent 3px),radial-gradient(ellipse at 48% 40%,#648567 0px 2px,transparent 3px),'+base;
    }
    if(/oceano/.test(n))return 'linear-gradient(125deg,#1d577f 0%,#4197b1 60%,#86c4d1 100%)';
    if(/sfumat/.test(n))return 'linear-gradient(105deg,#eee1d6 0%,#bf9eaa 37%,#88849e 68%,#c6d0c8 100%)';
    if(/safari|tropical|esotic|etnic|oriental|savana/.test(n)){
      var base=solid(n)||'#c8b79a';
      return 'radial-gradient(ellipse at 30% 75%,#415e4d 0px 3px,transparent 4px),linear-gradient(130deg,transparent 0% 41%,rgba(238,171,84,.9) 42% 50%,transparent 52%),'+base;
    }
    return null;
  }
  function colorPaint(raw) {
    var name=norm(raw);
    if(!name)return null;
    var motif=pattern(name);
    if(motif)return motif;
    var parts=name.split(/\s+(?:e|and|et|und|con)\s+|\s*[\/,&+]\s*/).filter(Boolean);
    var shades=parts.map(solid);
    if(!shades.length || shades.some(function(p){return !p;}))return null;
    if(shades.length===1)return shades[0];
    var stops=[];
    for(var i=0;i<shades.length;i++){
      stops.push(shades[i]+' '+(i*100/shades.length)+'% '+((i+1)*100/shades.length)+'%');
    }
    return 'linear-gradient(90deg,'+stops.join(',')+')';
  }
  function isColorOption(raw) {
    var s=norm(raw).replace(/^options\[/,'').replace(/\]$/,'').replace(/^\s*option[\s_-]?/,'');
    return /^(colore|colori|colors?|colour|couleur|colores|farbe|fantasia|colore e fantasia|colore cravatta)$/.test(s);
  }
  function getVariantPhoto(input) {
    var container=input.closest && input.closest('variant-radios');
    if(!container)return null;
    var data=container.querySelector('script[type="application/json"]');
    if(!data)return null;
    try{
      var variants=JSON.parse(data.textContent);
      for(var i=0;i<variants.length;i++){
        var v=variants[i];
        if(v.options&&v.options.indexOf(input.value)>-1){
          var u=v.featured_image&&v.featured_image.src;
          if(!u&&v.featured_media&&v.featured_media.preview_image)u=v.featured_media.preview_image.src;
          if(u && /^https?:\/\/|^\/\//.test(u))return 'url("'+u.replace(/"/g,'%22')+'")';
        }
      }
    }catch(ex){}
    return null;
  }
  function setSwatches() {
    var inputs=document.querySelectorAll('input[type="radio"]');
    for(var i=0;i<inputs.length;i++){
      var input=inputs[i];
      var groupName=input.getAttribute('name')||'';
      if(!isColorOption(groupName))continue;
      var label=input.labels&&input.labels.length?input.labels[0]:null;
      if(!label)continue;
      var paint=colorPaint(input.value);
      if(!paint)paint=getVariantPhoto(input);
      if(!paint){
        label.classList.add('hola-swatch-text','hola-swatch-no-color');
        continue;
      }
      label.style.setProperty('--hola-color',paint);
      label.classList.remove('hola-swatch-no-color');
      if(label.classList.contains('color-swatchimg') || label.classList.contains('swatch__swatch') ||
          (label.classList.contains('color-swatch') && !label.textContent.trim())){
        label.classList.add('hola-swatch-circle');
        label.setAttribute('title',input.value);
        label.setAttribute('aria-label',input.value);
        continue;
      }
      var inner=null;
      for(var c=0;c<label.children.length;c++){
        var el=label.children[c];
        if(/^(SPAN|I|DIV)$/i.test(el.tagName) && !el.textContent.trim() &&
          (el.className && /swatch|color|colour|circle|dot/i.test(String(el.className)))){
          inner=el;
          break;
        }
      }
      label.classList.add('hola-swatch-text');
      if(inner){
        inner.classList.add('hola-swatch-inner');
        label.classList.add('hola-swatch-with-inner');
      }else label.classList.remove('hola-swatch-with-inner');
    }
  }
  var queued=false;
  function schedule(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;setSwatches();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:reorder',schedule);
  if(document.body && window.MutationObserver){
    new window.MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  }
})();
